import * as React from "react";
const SvgArrowBackIosNew = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.77 3.77 16 2 6 12l10 10 1.77-1.77L9.54 12z",
  fill: "currentColor"
}));
export default SvgArrowBackIosNew;